import { addDecimals } from '../utils/cartUtils'

const FormattedPrice = ({ price }) => {
  return <span>${addDecimals(price)}</span>
}

export default FormattedPrice
